// extracted by mini-css-extract-plugin
export default {"thumb":"Scrollable_thumb__wh9rC"};